// removed by extract-text-webpack-plugin
module.exports = {"background":"src-components----journey-module---background---2deRA","container":"src-components----journey-module---container---GS4az src-pages----index-module---container---Eqp4Q","title":"src-components----journey-module---title---2A6dX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/journey.module.css
// module id = 129
// module chunks = 35783957827783 96961042003272